import React from 'react';
import { Provider } from "react-redux";
import { ThemeProvider } from "styled-components";
import { BrowserRouter as Router, Route } from "react-router-dom";

import './App.css';
import "./styles/global.scss";
import './styles/bootstrap-grid.css';
import "./styles/margins.scss";

import { theme } from './styles/theme';
import configureStore from './store';


import ScrollRestoration from './ScrollRestoration';
import Root from './containers/Root';

const store = configureStore();

function App() {
    return (
        <div className="App">
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <Router>
                        <ScrollRestoration>
                            <Root />
                        </ScrollRestoration>
                    </Router>
                </ThemeProvider>
            </Provider>
        </div>
    );
}

export default App;
